/* @flow */
import {Observable} from 'rxjs/Observable';
import type {ActionsObservable} from 'redux-observable';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/merge';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';

import {transformDataForReport} from 'nutshell-core/json-to-report-data';

import {
    updateLandingPagesReportTableData,
    updateLandingPagesReportChartData,
    updateLandingPagesSummaryStats,
    failLandingPagesReportChartData,
    type LandingPagesReportDataRequestedAction,
} from './pages-actions';

import {getLandingPagesReportPostParams, type LandingPagesReportPostParams} from './pages-utils';

export const requestLandingPagesReportDataEpic = (action$: ActionsObservable<*>) =>
    action$
        .ofType('LANDING_PAGES_REPORT_DATA_REQUESTED')
        .switchMap((action: LandingPagesReportDataRequestedAction) => {
            const {reportParams, filters} = action.payload;
            const params = getLandingPagesReportPostParams(reportParams, filters);

            const requestStream = Observable.fromPromise(fetchData(params));
            const currentResultStream = requestStream.map((res) => res[0]);
            const reportDataStream = requestStream.map(transformDataForReport);

            const reportTableDataStream = reportDataStream.map(({tableData}) =>
                updateLandingPagesReportTableData(tableData)
            );

            const reportChartDataStream = reportDataStream
                .map((data) => data.chartData)
                .filter((chartData) => Boolean(chartData))
                .map((chartData) => updateLandingPagesReportChartData({chartData}));

            const summaryStatStream = currentResultStream.map((currentResult) =>
                updateLandingPagesSummaryStats(currentResult.meta)
            );

            return reportChartDataStream
                .merge(summaryStatStream.merge(reportTableDataStream))
                .catch((err) => Observable.of(failLandingPagesReportChartData(err)));
        });

function fetchData(params: LandingPagesReportPostParams) {
    return Promise.all([fetchLandingPagesReportData(params)]);
}

function fetchLandingPagesReportData(params: LandingPagesReportPostParams): Promise<any> {
    const url = '/rest/landingpages/report';
    const ajaxParams = {
        url,
        dataType: 'json',
        data: params,
    };

    return ($.ajax(ajaxParams): any); // This is how we have to convince flow that the response is a ReportsResponse
}
